'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import Dialog from 'material-ui/Dialog'
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const client = require('./client');

const colorAccent = '#18202c'; // Blue: #0075A1 Navy Blue: #18202c
const colorHR = '#f28220'; // Green: #79B843 Orange: #f28220
const colorGray = '#e1e2e5';
const colorBlack = '#595959';

const muiTheme = getMuiTheme({
	fontFamily: "'Arial', sans-serif",
	palette: {
	    primary1Color: colorAccent,
	    accent1Color: colorAccent
	}
});

const paperStyle = {
		  height: '31%',
		  width: '30%',
		  textAlign: 'center',
		  display: 'inline-block',
		  overflow: 'auto',
		  position: 'absolute',
		  right: '35%',
		  marginTop: '75px',
		  minHeight: '300px'
		};


export default class LoginForm extends React.Component {
	
	//props: filterAttribute, filterValues
	constructor(props) {
		super(props);
	
		this.state = {
			error: false
	    };
		
		this.processForm = this.processForm.bind(this);
	}
	
	processForm(event) {
	    // prevent default action. in this case, action is the form submission event
	    event.preventDefault();
	    localStorage.setItem('user', this.refs.name.getValue());
	    localStorage.setItem('pwd', this.refs.password.getValue());
	    
		var lParams = {};
		lParams.user = localStorage.getItem('user');
		lParams.pwd = localStorage.getItem('pwd')
		
		client({method: 'GET',  path: 'tableautoken', params: lParams}).done(response => {
			var lTabToken =  response.entity.tabtoken;
			if (lTabToken == '') {
				lTabToken = "John"
			}
			if(lTabToken == "-1"){
				localStorage.clear();
				window.location = "#/Login";
				this.setState({
					error: true
				});
			}else{
				window.location = "#";
			}
		});
	    
	}
	
	render() {
		var form = this;
		return(
				<MuiThemeProvider muiTheme={muiTheme}>

				    <div className="loginPage">
						<div className="logoTop">
							<img src={"./img/X_white.png"} height= "150px" style={{textAlign: "center", margin: "auto", display: "block"}} />
						  	<img src={"./img/TabXMLogo.png"} height= "25px" style={{paddingTop: "7px", textAlign: "center", margin: "auto", display: "block"}} />
						</div>
						<Paper style={paperStyle}>
							<form action="/" onSubmit={this.processForm}>
					          <h2 id="loginTitle" className="card-heading">FRANCHISEE PORTAL</h2>
	
					          <div className="field-line">
					            <TextField ref="name" underlineStyle={{borderColor: '#1E9FD6'}} underlineFocusStyle={{color: '#1E9FD6'}} floatingLabelFixed={true} floatingLabelText="Name" />
					          </div>
	
					          <div className="field-line">
					          	{form.state.error?
						          	(<TextField ref="password" underlineStyle={{borderColor: '#1E9FD6'}} underlineFocusStyle={{color: '#1E9FD6'}} errorText="Incorrect Credentials" floatingLabelFixed={true} floatingLabelText="Password" type="password" />)
						          	:
					          		(<TextField ref="password" underlineStyle={{borderColor: '#1E9FD6'}} underlineFocusStyle={{color: '#1E9FD6'}} floatingLabelFixed={true} floatingLabelText="Password" type="password" />)
					          	}
					          </div>
	
					          <div className="button-line">
					            <RaisedButton labelColor="white" backgroundColor="#1E9FD6" type="submit" label="Login"/>
					          </div>
					          
					            
						      <div className="pwd-line">
						      		Credentials:  jsmith / Password: 123&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;jevans / Password: 123
						      </div>
					        </form>
						</Paper>
					</div>
				</MuiThemeProvider>		
		)
	}
}


// WEBPACK FOOTER //
// ./src/main/js/LoginForm.js